<script>
    import R, {LOADER} from "../../lib/requests";
    import PageHeader from "../../components/PageHeader.svelte";
    import PriceControl from "../../components/controls/PriceControl.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import ShippingItem from "./ShippingItem.svelte";
    import Couriers from "./Couriers.svelte";
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";

    const pageHeaderControls = [
        {id: 'create', name: 'ΠΡΟΣΘΗΚΗ ΖΩΝΗΣ', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];


    let list = null;
    let regions = null;
    let couriers = null;

    const load = () => {
        const onSuccess = result => {
            list = result.shipping;
            regions = result.regions;
            couriers = result.couriers;
        }

        const onFailure = err => {
        };


        R.handle(R.shipping.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const emptyShipping = () => {
        return {
            id: 0,
            name: '',
            extra_weight: null,
            extra_price: null,
            max_price: null,
            prices: [],
        }
    }

    const onCreate = () => {
        list = [...list, emptyShipping()];
    }

    const onChange = ({detail}) => {
        // dummy
    }

    const onDelete = ({detail}) => {
        let inRegions = 0;
        if (detail.id > 0) {
            inRegions = regions.filter(x => x.shipping_id == detail.id).length;
        }
        if (inRegions) {
            Alert.warning("Διαγραφή ζώνης", `Η ζώνη "${detail.name}" έχει συσχετιστεί με ${inRegions} νομούς.\nΔεν μπορείτε να διαγράψετε αυτή την ζώνη.`);
            return;
        }

        Alert.delete("Διαγραφή ζώνης", `Να διαγραφεί η ζώνη "${detail.name}" από τα μεταφορικά;`, () => deleteShipping(detail.id));
    }

    const deleteShipping = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
        }

        const onFailure = err => {
            if (err && err.code === 'object_related') {
                Alert.warning("Διαγραφή ζώνης", `Η διαγραφή της ζώνης δεν είναι δυνατή γιατί συνδέεται με ${err.params.regions} νομούς!`);
            }
        };

        if (id == 0) {
            list = list.filter(x => x.id > 0);
            return;
        }

        R.handle(R.shipping.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onRegionChange = region => {
        const onSuccess = result => {
            Notifier.showMessage("Ο νομός ενημερώθηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.region.edit, region, onSuccess, onFailure, LOADER.NONE);
    }

    load();
</script>

<PageHeader title="Μεταφορικά" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if list != null}
    <div class="row">
        <div class="col-xl-6 col-lg-7">
            <div class="panel panel-default mb-5">
                <div class="panel-heading">
                    Ζώνες
                </div>
                {#if list.length}
                    <table class="table table-list">
                        <thead>
                        <tr>
                            <th class="name-column">Ζώνη</th>
                            <th>Έξτρα βάρος</th>
                            <th>Τιμή</th>
                            <th>Μέγιστη τιμή</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {#each list as item}
                            <ShippingItem bind:shipping="{item}" on:change={ onChange } on:delete={ onDelete }/>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="panel-body panel-pad">
                        Δεν υπάρχουν μεταφορικά.
                    </div>
                {/if}
            </div>

            <Couriers {couriers}/>
        </div>

        <div class="col-xl-4 col-lg-5">
            <div class="panel panel-default">
                <div class="panel-heading">
                    Περιοχές
                </div>
                <table class="table table-list">
                    <thead>
                    <tr>
                        <th>Νομός</th>
                        <th>Μεταφ.</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each regions as region}
                        <tr>
                            <td>{ region.name }</td>
                            <td>
                                <select class="form-select" bind:value="{ region.shipping_id }" on:change={ () => onRegionChange(region) }>
                                    <option value="0">επιλογή ζώνης</option>
                                    {#each list as item}
                                        {#if item.id > 0}
                                            <option value="{ item.id }">{ item.name }</option>
                                        {/if}
                                    {/each}
                                </select>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
{/if}
